// ZooRoyal theme import
@use '../../zr-theme/zr-variables.scss' as *;
@use '../../zr-theme/zr-theme.scss';
@use '../../zr-theme/functions/fonts' as f;
@use '../../zr-css-icon/zr-css-icon.scss' as i;

$component: 'product';

:host {
    /***
     ADD THEME VARS IN TEMPLATE FILE
     --> themes/Frontend/ZRDefault/frontend/index/header.tpl
     ***/

    display: grid;
    grid-template-columns: 1fr max-content;
    column-gap: 5px;
    margin-top: 10px;

    .schema-org-prop {
        display: none;
    }

    p {
        margin-bottom: 24px;
    }

    .#{$component}__supplier {
        padding: 4px 0;
        text-align: left;
        grid-column: 1/2;

        a {
            transition: color .2s ease-out;
            color: var(--ci-neutral900);
            font-weight: normal;
            font-size: f.calc-em(16);
            text-decoration: none;
            cursor: pointer;

            &:hover {
                color: var(--ci-primary400);
                text-decoration: underline;
            }
        }
    }

    .#{$component}__name {
        text-align: left;
        grid-column: 1/3;
        margin-top: 0;
        font-family: 'Museo Sans Rounded', sans-serif;
        margin-bottom: $grid-gap;
        font-size: f.calc-em(36);
        line-height: 1.3em;
    }

    zr-rating-badge {
        justify-self: end;
        gap: 4px;
        grid-column: 2/3;

    }

    .#{$component}__short-rating-icon {
        @include i.get-icon-only(star-gold);
    }

    .#{$component}__image-wrapper {
        position: relative;
        grid-column: 1/3;
        height: calc(100vw + 15px);
        margin-bottom: $grid-gap;
    }

    zr-energy-label {
        margin-bottom: $grid-gap;
        grid-column: 1/3;
    }

    zr-variant-switch {
        grid-column: 1/3;
        margin-bottom: $grid-gap;
        visibility: var(--vx-variant-switch-visibility, hidden);
    }

    zr-loyalty-price {
        grid-column: 2 / 3;
    }

    .zr-to-cart-quantity-wrapper {
        display: grid;
        grid-template-columns: 1fr min-content;
        gap: 8px 16px;
        justify-content: space-between;
        grid-column: 1/3;
        margin-bottom: $grid-gap;

        label {
            color: var(--ci-neutral800);
            margin: auto 0;
            font-size: f.calc-em(14);
            font-weight: 300;
            line-height: f.calc-em(20);
            grid-column: 1/3;
        }

        vx-select {
            width: 100%;
        }

        vx-select::part(select) {
            @media only screen and (min-width: $tablet-screen) {
                height: 40px;
            }
        }

        zr-wishlist {
            border-radius: 50%;
        }
    }

    .price-wrapper-loyalty{
        grid-column: 1/2;
        margin-bottom: $grid-gap;
    }

    .price-wrapper {
        grid-template-columns: auto 1fr;
        grid-template-rows: auto auto;
        grid-column: 1/2;
        margin-bottom: $grid-gap;

        flex-flow: column;
        display: flex;
        align-items: start;
    }

    .payback-wrapper {
        grid-column: 2/3;
        margin-bottom: $grid-gap;
        align-self: end;

        zr-payback {
            flex-direction: column;
            align-items: end;
            justify-content: center;
        }
    }

    vx-add-to-cart,
    .zr-link-to-club-button{
        grid-column: 1/3;
        margin-bottom: $grid-gap;
    }

    zr-shipping-information {
        grid-column: 1/3;
        margin-bottom: $grid-gap;
    }

    zr-loyalty-points-price-info {
        grid-column: 1/3;
        margin-bottom: $grid-gap;
    }

    zr-warning-notice {
        grid-column: 1/3;
        margin-bottom: $grid-gap;
    }

    zr-usp {
        grid-column: 1/3;
        margin-bottom: $grid-gap;
    }


    zr-accordion-group {
        margin-bottom: $grid-gap;
    }

    .content {
        grid-column: 1/3;

        // styles for tables inside the product-description
        table {
            border-collapse: collapse;
            min-width: 100%;
            max-width: 100%;

            tbody {
                tr {
                    font-weight: 300;
                    font-size: 1em;
                    line-height: f.calc-em(24);
                    border-bottom: 1px solid var(--ci-neutral300);
                    color: var(--ci-neutral800);

                    td {
                        padding: 8px;
                    }
                }

                tr:first-child {
                    border-bottom: 1px solid var(--ci-neutral400);
                    font-weight: 600;
                }
            }
        }
    }

    zr-rating {
        grid-column: 1/3;
        margin-bottom: $grid-gap;
    }

    table {
        font-size: 14px !important;
        display: block;
        overflow-x: auto;

        td {
            padding: 4px !important;
        }
    }
}

// media query: tablet and above
@media only screen and (min-width: $tablet-screen) {
    $grid-gap: 32px;

    :host {
        display: grid;
        grid-template-columns: calc(65% - $grid-gap) 35%;
        grid-template-rows:
            30px                    // Supplier and Star
            auto                    // ProductName
            auto                    // Variations
            calc(42px + $grid-gap)  // QualitySelect
            auto                    // Price / Payback
            calc(48px + $grid-gap)  // Add To Card Btn
            calc(60px + $grid-gap); // DeliveryInfo
        grid-auto-flow: column;
        grid-column-gap: $grid-gap;

        .#{$component}__image-wrapper {
            height: auto;
            grid-column: 1/2;
            grid-row: 1/8;
            margin-bottom: 0;
        }

        .#{$component}__supplier {
            padding: 4px 0;
            text-align: left;
            grid-column: 2/3;
            grid-row: 1/2;
        }

        .is-above-thumbnail {
            position: relative;
            left: 110px;
            top: 60px;
            z-index: 2;
        }

        zr-rating-badge {
            grid-column: 2/3;
            grid-row: 1/2;
            z-index: 4;
        }

        .#{$component}__name {
            text-align: left;
            grid-column: 2/3;
            margin-bottom: 20px;
        }

        zr-variant-switch {
            grid-column: 2/3;
        }

        .zr-to-cart-quantity-wrapper {
            grid-template-columns: min-content 1fr min-content;
            grid-column: 2/3;
            align-items: center;

            label {
                color: var(--ci-neutral800);
                margin: auto 0;
                font-size: f.calc-em(16);
                font-weight: 300;
                line-height: f.calc-em(24);
                grid-column: 1/2;
            }
        }

        .price-wrapper-loyalty{
            grid-column: 2/3;
            text-align: right;
            display: flex;
            justify-content: end;
            align-items: center;
            margin-bottom: 0;
        }

        .price-wrapper {
            display: grid;
            position: relative;
            grid-column: 2/3;
            grid-row: 5/6;
            margin-bottom: $grid-gap;
            grid-template-columns: auto;
            text-align: end;
        }

        .payback-wrapper {
            grid-column: 2/3;
            grid-row: 5/6;
            align-self: end;
            margin-bottom: $grid-gap;

            zr-payback {
                flex-direction: column;
                align-items: end;
                justify-content: center;
            }
        }

        vx-add-to-cart,
        .zr-link-to-club-button {
            grid-column: 2/3;
            margin-bottom: $grid-gap;
        }

        zr-shipping-information {
            grid-column: 2/3;
        }

        zr-loyalty-points-price-info {
            grid-column: 2/3;
        }

        zr-warning-notice {
            grid-column: 1/2;
            margin-bottom: $grid-gap;
        }

        zr-energy-label {
            margin-bottom: 15px;
            grid-column: 1/2;
        }

        zr-usp {
            grid-column: 2/3;
            grid-row: span 2;
        }

        zr-rating {
            grid-column: 2/3;
            grid-row: span 3;
        }

        .content {
            grid-column: 1/2;
            grid-row: span 11;

            .product-description {
                table {
                    min-width: 50%;

                    tbody {
                        tr {
                            font-size: f.calc-em(16);
                            line-height: f.calc-em(24);
                        }

                        td {
                            padding: 8px;
                        }
                    }
                }
            }
        }
    }
}

zr-tooltip {
    --zr-tooltip-background-color: #1da555;
    text-align: -webkit-right;
    margin-bottom: 6px;

    &::part(wrapper) {
        display: block;
        opacity: 1;
        animation: none;
    }

    &::part(content) {
        position: relative;
        right: 0;
        top: 0;
        transform: none;
        margin: 0;
        font-size: 14px;
    }
}
